/**
 * Utilitaires pour la manipulation HTML sécurisée
 */

/**
 * Échappe les caractères HTML pour éviter les injections XSS
 * @param {string} text - Le texte à échapper
 * @returns {string} Le texte échappé et sécurisé
 */
export function escapeHtml(text) {
    if (!text) return '';
    
    // Convert to string if needed
    const str = String(text);
    
    // Escape all dangerous characters
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
}
